angular.module 'App.Service', []
angular.module 'App.Repository', []
angular.module 'App.Component', []
angular.module 'App.Directive', [
	'App.Directive.EpicConfiguration'
	'App.Directive.PurchaseOrder'
]
# {@link https://www.npmjs.com/package/gulp-angular-templatecache}
angular.module 'App.Templates', []
angular.module 'App.Value', []
angular.module 'App.Filter', []
angular.module 'App.Module.Controller', []
angular.module 'App.Module',
	[
		'App.Module.Account'
		'App.Module.Account.Payment'
		'App.Module.Adyen'
		'App.Module.Controller'
		'App.Module.BaseSearch'
		'App.Module.CurrencyConversionRates'
		'App.Module.Customer'
		'App.Module.CustomerDisplay'
		'App.Module.CustomerGroup'
		'App.Module.CustomerPrefix'
		'App.Module.DiscountReasonCode'
		'App.Module.Documentation'
		'App.Module.Empty'
		'App.Module.EntityManagement'
		'App.Module.Home'
		'App.Module.Inventory.StockLocations'
		'App.Module.InventoryCount'
		'App.Module.Journal'
		'App.Module.Kpi'
		'App.Module.Pusher'
		'App.Module.Login'
		'App.Module.LayoutTemplate'
		'App.Module.Report'
		'App.Module.Product'
		'App.Module.ProductCategory'
		'App.Module.PurchaseOrder'
		'App.Module.PredefinedDiscount'
		'App.Module.PredefinedLineitemDiscount'
		'App.Module.PromotionCampaign'
		'App.Module.PriceRegion'
		'App.Module.Role'
		'App.Module.Register'
		'App.Module.ReasonCode'
		'App.Module.ReturnReasonCode'
		'App.Module.CashMovementEventReason'
		'App.Module.ResetPassword'
		'App.Module.Shop'
		'App.Module.ShopGroup'
		'App.Module.VatRate'
		'App.Module.VatRateOverrideGroupModule'
		'App.Module.Subscriber'
		'App.Module.Supplier',
		'App.Module.ShippingMethod',
		'App.Module.ProductFilter',
		'App.Module.TenderTypes'
		'App.Module.Tickets'
		'App.Module.TicketEvents'
		'App.Module.TicketTypes'
		'App.Module.TrackingCategory'
		'App.Module.User'
		'App.Module.Vouchers'
		'App.Module.VoucherTypes'
		'App.Module.Strategy'
		'App.Module.Configuration'
		'App.Module.Integration'
		'App.Module.IntegrationLog'
		'App.Module.BulkDataLog'
	]
